import React, { Component } from 'react';
import Chip from '../Chip';
import { List } from 'immutable';

import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

class MultipleSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedIds: List(),
    };
  }

  handleSelected = (e, i, id) => {
    e.preventDefault();
    if (typeof id !== 'number') return;

    const selectedIds = this.state.selectedIds.push(id);
    this.setState({
      selectedIds: selectedIds,
    });
    this.props.onChange(selectedIds);
  };

  handleRemoveSelected = (id) => {
    const selectedIds = this.state.selectedIds.delete(
      this.state.selectedIds.indexOf(id)
    );

    this.setState({
      selectedIds: selectedIds,
    });
    this.props.onChange(selectedIds);
  };

  render() {
    const entities = this.props.items;
    return (
      <div>
        {this.state.selectedIds.map(id =>
          <Chip
            key={id}
            label={entities.get(`${id}`).get('name')}
            onCancel={this.handleRemoveSelected.bind(this, id)}
          />
        )}
        <DropDownMenu
          maxHeight={300}
          value="default"
          onChange={this.handleSelected}
          style={{ display: 'block' }}
        >
          <MenuItem
            key="default"
            value="default"
            primaryText={this.props.hintText}
          />
          {this.props.result
            .filterNot(id => ~this.state.selectedIds.indexOf(id))
            .map(id =>
            <MenuItem
              key={entities.get(`${id}`).get('slug')}
              value={entities.get(`${id}`).get('id')}
              primaryText={entities.get(`${id}`).get('name')}
            />
          )}
        </DropDownMenu>
      </div>
    );
  };
}

export default MultipleSelect;



/** WEBPACK FOOTER **
 ** ./components/forms/MultipleSelect.js
 **/